.tabs {
  padding-bottom: var(--spacingLg);
}
